/**
 * 列表查询参数拼装。
 *
 * scr 后端三个 Query 结构体（demand.Query / alert.Query / response.Query）的字段
 * **既没有 form tag，也不是 gin 的 tag 默认值**：gin v1.10 的查询绑定是
 * `setByForm` 里的 `form[tagValue]` 精确 map 查找，tagValue 缺省取 Go 字段名，
 * 既不认小驼峰（page）也不认下划线（source_module），对不上的 key 被**静默丢弃**
 * （实测 ShouldBindQuery(&Query{Page int}) 收到 page=2 之后 Page 仍是 0）。
 *
 * 所以每个参数送两套 key：Go 字段名（现在就能被绑定）与小写下划线
 * （后端补上 form tag 后不必再动前端）。gin 只按字段名找，多余的 key 直接忽略、不报错。
 */
const GO_FIELD: Record<string, string> = {
  page: 'Page',
  size: 'Size',
  keyword: 'Keyword',
  status: 'Status',
  level: 'Level',
  source: 'Source',
  source_module: 'SourceModule',
  priority: 'Priority',
  action: 'Action',
  alert_id: 'AlertID',
  demand_id: 'DemandID',
}

/**
 * 去掉没填的筛选项并补上 Go 字段名副本。
 * 空串与 undefined / null 都不上送：后端按 `if q.X != ""` 过滤，多送空串等于多一次无用比较，
 * undefined 还会让 axios 把参数整个丢掉，两种都得在本地先清掉。
 * 字符串顺手 trim —— 只打了空格的关键词等价于没填，而 LIKE '%%' 会把整张表扫一遍。
 */
export function listQuery(q: Record<string, unknown>): Record<string, unknown> {
  const out: Record<string, unknown> = {}
  for (const [key, raw] of Object.entries(q)) {
    if (raw === undefined || raw === null) continue
    const value = typeof raw === 'string' ? raw.trim() : raw
    if (value === '') continue
    out[key] = value
    const go = GO_FIELD[key]
    if (go) out[go] = value
  }
  return out
}

/** 列表查询里可能用到的全部 key，与 GO_FIELD 对照，避免新增筛选项忘了配 Go 字段名 */
export const LIST_QUERY_KEYS = Object.keys(GO_FIELD)
